import { render, staticRenderFns } from "./admin-signatures.vue?vue&type=template&id=23918924&scoped=true&"
import script from "./admin-signatures.vue?vue&type=script&lang=js&"
export * from "./admin-signatures.vue?vue&type=script&lang=js&"
import style0 from "./admin-signatures.vue?vue&type=style&index=0&id=23918924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23918924",
  null
  
)

export default component.exports